module.exports = __webpack_public_path__ + "img/acacia_mweya10.b1a27e0e.jpg";